import type { TableColumnSchema } from "./types";

type SourceRow = Record<string, unknown>;

export const getRowsFromTablePayload = (payload: unknown): unknown[] => {
	if (Array.isArray(payload)) return payload;
	if (payload && typeof payload === "object" && Array.isArray((payload as { data?: unknown }).data)) {
		return (payload as { data: unknown[] }).data;
	}
	return [];
};

export const normalizeTableRowForColumns = (
	row: unknown,
	columns: TableColumnSchema[],
	columnMapping?: Record<string, string> | null
): Record<string, string> => {
	const source: SourceRow = row && typeof row === "object" ? (row as SourceRow) : {};
	const mapped: Record<string, string> = {};

	columns.forEach((col) => {
		const mappedColumn = columnMapping?.[col.name];
		const value = mappedColumn && source[mappedColumn] != null ? source[mappedColumn] : source[col.name];
		mapped[col.name] = value != null ? String(value) : "";
	});

	return mapped;
};

export const normalizeTableRowsForColumns = (
	rows: unknown,
	columns: TableColumnSchema[],
	columnMapping?: Record<string, string> | null
): Record<string, string>[] => {
	if (!Array.isArray(rows)) return [];
	return rows.map((row) => normalizeTableRowForColumns(row, columns, columnMapping));
};
